import { CircularProgress } from '@ixigo/iui/CircularProgress';
import Typography from '@ixigo/iui/Typography';
import { ContentFader } from '../content-cycle-animator';
import {
	ResponsiveModal,
	type ResponsiveModalProps,
} from '../responsive-modal';

export const SpinningLoaderContent = ({
	title = '',
	descriptions,
	className = '',
}: {
	title?: string;
	descriptions: string[];
	className?: string;
}) => {
	const contentList = descriptions.map((description, index) => (
		<Typography variant="body-sm" className="text-secondary" key={index}>
			{description}
		</Typography>
	));
	return (
		<div className={className}>
			<CircularProgress
				value={25}
				size={60}
				spin={true}
				className="text-subbrand-500"
			/>
			<div className="flex flex-col items-center gap-5 w-full text-center">
				<Typography variant="body-md" fontWeight="medium">
					{title}
				</Typography>
				<ContentFader contentList={contentList} className="w-full h-20" />
			</div>
		</div>
	);
};

interface SpiningLoaderProps
	extends Omit<
		ResponsiveModalProps,
		'fullScreen' | 'children' | 'transitionDirection'
	> {
	title?: string;
	descriptions?: string[];
}

export const SpinningLoader = ({
	title = '',
	descriptions = [],
	...props
}: SpiningLoaderProps) => {
	return (
		<ResponsiveModal {...props} fullScreen transitionDirection="right">
			<SpinningLoaderContent
				title={title}
				descriptions={descriptions}
				className="fixed top-0 left-0 h-screen w-screen flex flex-col gap-2.5 justify-center items-center bg-primary"
			/>
		</ResponsiveModal>
	);
};
